import React from 'react';

function FormTitle(props) {
    return (
        <h4 className="text-center">
            Let's evaluate your meeting efficiency with Machine Learning Model! 
        </h4>
    );
}

export default FormTitle;
